var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ezaFS81XVJn1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1559.72 1039.82",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn9-stroke",
    x1: -28.48,
    y1: 898.43,
    x2: 1669.12,
    y2: 898.43,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn9-stroke-0",
    offset: "0%",
    stopColor: "#ff0fa3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn9-stroke-1",
    offset: "12%",
    stopColor: "#e618ab"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn9-stroke-2",
    offset: "39%",
    stopColor: "#a630c2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn9-stroke-3",
    offset: "77%",
    stopColor: "#4156e7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn9-stroke-4",
    offset: "100%",
    stopColor: "#006fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn10-stroke",
    x1: -29.83,
    y1: 884.44,
    x2: 1668.33,
    y2: 884.44,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn10-stroke-0",
    offset: "0%",
    stopColor: "#f817a6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn10-stroke-1",
    offset: "13%",
    stopColor: "#df1fae"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn10-stroke-2",
    offset: "40%",
    stopColor: "#a035c5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn10-stroke-3",
    offset: "80%",
    stopColor: "#3c58e8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn10-stroke-4",
    offset: "100%",
    stopColor: "#076bfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn11-stroke",
    x1: -31.18,
    y1: 870.41,
    x2: 1667.54,
    y2: 870.41,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn11-stroke-0",
    offset: "0%",
    stopColor: "#f01faa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn11-stroke-1",
    offset: "14%",
    stopColor: "#d726b2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn11-stroke-2",
    offset: "42%",
    stopColor: "#993ac7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn11-stroke-3",
    offset: "84%",
    stopColor: "#3659e9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn11-stroke-4",
    offset: "100%",
    stopColor: "#0d67f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn12-stroke",
    x1: -32.53,
    y1: 856.34,
    x2: 1666.74,
    y2: 856.34,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn12-stroke-0",
    offset: "0%",
    stopColor: "#e926ad"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn12-stroke-1",
    offset: "14%",
    stopColor: "#d12cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn12-stroke-2",
    offset: "44%",
    stopColor: "#933ec9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn12-stroke-3",
    offset: "88%",
    stopColor: "#315aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn12-stroke-4",
    offset: "100%",
    stopColor: "#1463f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn13-stroke",
    x1: -33.87,
    y1: 842.19,
    x2: 1665.95,
    y2: 842.19,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn13-stroke-0",
    offset: "0%",
    stopColor: "#e12eb0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn13-stroke-1",
    offset: "15%",
    stopColor: "#c933b7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn13-stroke-2",
    offset: "47%",
    stopColor: "#8c43cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn13-stroke-3",
    offset: "93%",
    stopColor: "#2a5bec"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn13-stroke-4",
    offset: "100%",
    stopColor: "#1b5ff2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn14-stroke",
    x1: -35.22,
    y1: 827.98,
    x2: 1665.16,
    y2: 827.98,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn14-stroke-0",
    offset: "0%",
    stopColor: "#da36b3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn14-stroke-1",
    offset: "16%",
    stopColor: "#c23aba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn14-stroke-2",
    offset: "50%",
    stopColor: "#8546cd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn14-stroke-3",
    offset: "98%",
    stopColor: "#255aec"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn14-stroke-4",
    offset: "100%",
    stopColor: "#215bee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn15-stroke",
    x1: -36.57,
    y1: 813.66,
    x2: 1664.37,
    y2: 813.66,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn15-stroke-0",
    offset: "0%",
    stopColor: "#d33eb7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn15-stroke-1",
    offset: "17%",
    stopColor: "#bb41be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn15-stroke-2",
    offset: "53%",
    stopColor: "#7f4ad0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn15-stroke-3",
    offset: "100%",
    stopColor: "#2857eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn16-stroke",
    x1: -37.92,
    y1: 799.23,
    x2: 1663.58,
    y2: 799.23,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn16-stroke-0",
    offset: "0%",
    stopColor: "#cb46ba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn16-stroke-1",
    offset: "18%",
    stopColor: "#b347c0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn16-stroke-2",
    offset: "57%",
    stopColor: "#784cd2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn16-stroke-3",
    offset: "100%",
    stopColor: "#2f53e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn17-stroke",
    x1: -39.27,
    y1: 784.63,
    x2: 1662.78,
    y2: 784.63,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn17-stroke-0",
    offset: "0%",
    stopColor: "#c44ebd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn17-stroke-1",
    offset: "20%",
    stopColor: "#ad4ec3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn17-stroke-2",
    offset: "60%",
    stopColor: "#724ed3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn17-stroke-3",
    offset: "100%",
    stopColor: "#354fe4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn18-stroke",
    x1: -40.61,
    y1: 769.81,
    x2: 1661.99,
    y2: 769.81,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn18-stroke-0",
    offset: "0%",
    stopColor: "#bc55c1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn18-stroke-1",
    offset: "21%",
    stopColor: "#a553c6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn18-stroke-2",
    offset: "66%",
    stopColor: "#6b4ed5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn18-stroke-3",
    offset: "100%",
    stopColor: "#3c4be1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn19-stroke",
    x1: -41.96,
    y1: 754.71,
    x2: 1661.2,
    y2: 754.71,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn19-stroke-0",
    offset: "0%",
    stopColor: "#b55dc4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn19-stroke-1",
    offset: "23%",
    stopColor: "#9e58c8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn19-stroke-2",
    offset: "72%",
    stopColor: "#654dd5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn19-stroke-3",
    offset: "100%",
    stopColor: "#4247dd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn20-stroke",
    x1: -43.31,
    y1: 739.22,
    x2: 1660.41,
    y2: 739.22,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn20-stroke-0",
    offset: "0%",
    stopColor: "#ae65c7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn20-stroke-1",
    offset: "26%",
    stopColor: "#975dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn20-stroke-2",
    offset: "80%",
    stopColor: "#5f4ad5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn20-stroke-3",
    offset: "100%",
    stopColor: "#4943da"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn21-stroke",
    x1: -44.66,
    y1: 723.17,
    x2: 1659.62,
    y2: 723.17,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn21-stroke-0",
    offset: "0%",
    stopColor: "#a66dca"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn21-stroke-1",
    offset: "30%",
    stopColor: "#9061cd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn21-stroke-2",
    offset: "92%",
    stopColor: "#5743d5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn21-stroke-3",
    offset: "100%",
    stopColor: "#503fd7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn22-stroke",
    x1: -46,
    y1: 706.36,
    x2: 1658.82,
    y2: 706.36,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn22-stroke-0",
    offset: "0%",
    stopColor: "#9f75ce"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn22-stroke-1",
    offset: "34%",
    stopColor: "#8963cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn22-stroke-2",
    offset: "100%",
    stopColor: "#563bd3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn23-stroke",
    x1: -47.35,
    y1: 688.54,
    x2: 1658.03,
    y2: 688.54,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn23-stroke-0",
    offset: "0%",
    stopColor: "#977dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn23-stroke-1",
    offset: "35%",
    stopColor: "#8567d0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn23-stroke-2",
    offset: "100%",
    stopColor: "#5d37d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn24-stroke",
    x1: -48.7,
    y1: 669.44,
    x2: 1657.24,
    y2: 669.44,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn24-stroke-0",
    offset: "0%",
    stopColor: "#9084d4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn24-stroke-1",
    offset: "31%",
    stopColor: "#846ed2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn24-stroke-2",
    offset: "96%",
    stopColor: "#6637cd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn24-stroke-3",
    offset: "100%",
    stopColor: "#6434cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn25-stroke",
    x1: -50.05,
    y1: 648.88,
    x2: 1656.45,
    y2: 648.88,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn25-stroke-0",
    offset: "0%",
    stopColor: "#898cd8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn25-stroke-1",
    offset: "27%",
    stopColor: "#8176d4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn25-stroke-2",
    offset: "84%",
    stopColor: "#6f40cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn25-stroke-3",
    offset: "100%",
    stopColor: "#6a30c9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn26-stroke",
    x1: -51.39,
    y1: 626.83,
    x2: 1655.66,
    y2: 626.83,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn26-stroke-0",
    offset: "0%",
    stopColor: "#8194db"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn26-stroke-1",
    offset: "25%",
    stopColor: "#7d7fd6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn26-stroke-2",
    offset: "75%",
    stopColor: "#7549cb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn26-stroke-3",
    offset: "100%",
    stopColor: "#712cc6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn27-stroke",
    x1: -52.74,
    y1: 604.2,
    x2: 1654.86,
    y2: 604.2,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn27-stroke-0",
    offset: "0%",
    stopColor: "#7a9cde"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn27-stroke-1",
    offset: "22%",
    stopColor: "#7987d9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn27-stroke-2",
    offset: "67%",
    stopColor: "#7851cc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn27-stroke-3",
    offset: "100%",
    stopColor: "#7828c3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn28-stroke",
    x1: -54.09,
    y1: 589.03,
    x2: 1654.07,
    y2: 589.03,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn28-stroke-0",
    offset: "0%",
    stopColor: "#73a4e1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn28-stroke-1",
    offset: "20%",
    stopColor: "#748fdb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn28-stroke-2",
    offset: "61%",
    stopColor: "#795acd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn28-stroke-3",
    offset: "100%",
    stopColor: "#7e24bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn29-stroke",
    x1: -55.44,
    y1: 575.74,
    x2: 1653.28,
    y2: 575.74,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn29-stroke-0",
    offset: "0%",
    stopColor: "#6babe5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn29-stroke-1",
    offset: "19%",
    stopColor: "#6e96de"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn29-stroke-2",
    offset: "57%",
    stopColor: "#7861cf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn29-stroke-3",
    offset: "100%",
    stopColor: "#8520bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn30-stroke",
    x1: -56.79,
    y1: 563.35,
    x2: 1652.49,
    y2: 563.35,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn30-stroke-0",
    offset: "0%",
    stopColor: "#64b3e8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn30-stroke-1",
    offset: "17%",
    stopColor: "#699ee1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn30-stroke-2",
    offset: "53%",
    stopColor: "#776ad1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn30-stroke-3",
    offset: "100%",
    stopColor: "#8c1cb9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn31-stroke",
    x1: -58.13,
    y1: 551.29,
    x2: 1651.7,
    y2: 551.29,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn31-stroke-0",
    offset: "0%",
    stopColor: "#5cbbeb"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn31-stroke-1",
    offset: "16%",
    stopColor: "#62a6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn31-stroke-2",
    offset: "49%",
    stopColor: "#7372d3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn31-stroke-3",
    offset: "96%",
    stopColor: "#8f1fb7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn31-stroke-4",
    offset: "100%",
    stopColor: "#9218b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn32-stroke",
    x1: -59.48,
    y1: 539.31,
    x2: 1650.9,
    y2: 539.31,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn32-stroke-0",
    offset: "0%",
    stopColor: "#55c3ef"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn32-stroke-1",
    offset: "15%",
    stopColor: "#5cafe8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn32-stroke-2",
    offset: "46%",
    stopColor: "#707bd6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn32-stroke-3",
    offset: "89%",
    stopColor: "#9029b9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn32-stroke-4",
    offset: "100%",
    stopColor: "#9914b2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn33-stroke",
    x1: -60.83,
    y1: 527.28,
    x2: 1650.11,
    y2: 527.28,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn33-stroke-0",
    offset: "0%",
    stopColor: "#4ecbf2"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn33-stroke-1",
    offset: "14%",
    stopColor: "#56b7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn33-stroke-2",
    offset: "43%",
    stopColor: "#6c84d8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn33-stroke-3",
    offset: "84%",
    stopColor: "#9032ba"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn33-stroke-4",
    offset: "100%",
    stopColor: "#9f10ae"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn34-stroke",
    x1: -62.18,
    y1: 515.17,
    x2: 1649.32,
    y2: 515.17,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn34-stroke-0",
    offset: "0%",
    stopColor: "#46d3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn34-stroke-1",
    offset: "13%",
    stopColor: "#4fbfed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn34-stroke-2",
    offset: "41%",
    stopColor: "#678cda"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn34-stroke-3",
    offset: "79%",
    stopColor: "#8f3bbc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn34-stroke-4",
    offset: "100%",
    stopColor: "#a60cab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn35-stroke",
    x1: -63.52,
    y1: 502.96,
    x2: 1648.53,
    y2: 502.96,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn35-stroke-0",
    offset: "0%",
    stopColor: "#3fdaf8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn35-stroke-1",
    offset: "13%",
    stopColor: "#49c6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn35-stroke-2",
    offset: "38%",
    stopColor: "#6394dd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn35-stroke-3",
    offset: "75%",
    stopColor: "#8d43be"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn35-stroke-4",
    offset: "100%",
    stopColor: "#ad08a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn36-stroke",
    x1: -64.87,
    y1: 490.62,
    x2: 1647.74,
    y2: 490.62,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn36-stroke-0",
    offset: "0%",
    stopColor: "#37e2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn36-stroke-1",
    offset: "12%",
    stopColor: "#41cef4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn36-stroke-2",
    offset: "36%",
    stopColor: "#5d9ce0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn36-stroke-3",
    offset: "71%",
    stopColor: "#8a4cc0"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn36-stroke-4",
    offset: "100%",
    stopColor: "#b304a4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ezaFS81XVJn37-stroke",
    x1: -66.22,
    y1: 478.18,
    x2: 1646.94,
    y2: 478.18,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn37-stroke-0",
    offset: "0%",
    stopColor: "#30eaff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn37-stroke-1",
    offset: "11%",
    stopColor: "#3bd6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn37-stroke-2",
    offset: "35%",
    stopColor: "#58a5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn37-stroke-3",
    offset: "67%",
    stopColor: "#8755c3"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "ezaFS81XVJn37-stroke-4",
    offset: "100%",
    stopColor: "#ba00a1"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    transform: "translate(0 0.000014)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ezaFS81XVJn38)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.021489 0.086861-.079793-.938369 1724.625824 1323.650851)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-18.41,1253.37c947.05-310.12,1331-1233.16,1684.42-310.6",
    fill: "none",
    stroke: "url(#ezaFS81XVJn9-stroke)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,9.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-19.99,1222.03C922.76,908.21,1302.41,56.48,1665.19,928.7",
    fill: "none",
    stroke: "url(#ezaFS81XVJn10-stroke)",
    strokeWidth: 2.9,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,8.83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-21.57,1190.7C916.88,873.16,1292.23,92.75,1664.35,914.63",
    fill: "none",
    stroke: "url(#ezaFS81XVJn11-stroke)",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,8.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.17,1159.37C910.99,838.1,1282.04,128.99,1663.52,900.58",
    fill: "none",
    stroke: "url(#ezaFS81XVJn12-stroke)",
    strokeWidth: 2.71,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,8.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-24.73,1128.04C905.11,803.02,1271.86,165.25,1662.68,886.52",
    fill: "none",
    stroke: "url(#ezaFS81XVJn13-stroke)",
    strokeWidth: 2.61,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26.32,1096.72C899.22,767.93,1261.67,201.51,1661.83,872.49",
    fill: "none",
    stroke: "url(#ezaFS81XVJn14-stroke)",
    strokeWidth: 2.51,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,8.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.9,1065.39C893.34,732.82,1251.47,237.75,1660.98,858.46",
    fill: "none",
    stroke: "url(#ezaFS81XVJn15-stroke)",
    strokeWidth: 2.41,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,7.93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29.5,1034.07C887.45,697.7,1241.28,273.97,1660.13,844.45",
    fill: "none",
    stroke: "url(#ezaFS81XVJn16-stroke)",
    strokeWidth: 2.31,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,7.74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-31.06,1002.74c912.63-340.18,1262.15-692.53,1690.33-172.3",
    fill: "none",
    stroke: "url(#ezaFS81XVJn17-stroke)",
    strokeWidth: 2.21,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,7.58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32.63,971.42C875.69,627.41,1220.91,346.43,1658.42,816.46",
    fill: "none",
    stroke: "url(#ezaFS81XVJn18-stroke)",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,7.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-34.22,940.1C869.82,592.24,1210.72,382.62,1657.57,802.5",
    fill: "none",
    stroke: "url(#ezaFS81XVJn19-stroke)",
    strokeWidth: 2.02,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,7.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-35.8,908.79C863.95,557.06,1200.54,418.83,1656.73,788.56",
    fill: "none",
    stroke: "url(#ezaFS81XVJn20-stroke)",
    strokeWidth: 1.92,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,7.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-37.37,877.47C858.09,521.86,1190.35,455.02,1655.88,774.63",
    fill: "none",
    stroke: "url(#ezaFS81XVJn21-stroke)",
    strokeWidth: 1.82,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,6.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38.95,846.15c891.19-359.52,1219.13-354.94,1694.01-85.43",
    fill: "none",
    stroke: "url(#ezaFS81XVJn22-stroke)",
    strokeWidth: 1.72,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,6.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.53,814.84c886.94-363.46,1210.55-287.44,1694.8-68.01",
    fill: "none",
    stroke: "url(#ezaFS81XVJn23-stroke)",
    strokeWidth: 1.62,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,6.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42.1,783.53c882.69-367.41,1201.97-219.92,1695.59-50.59",
    fill: "none",
    stroke: "url(#ezaFS81XVJn24-stroke)",
    strokeWidth: 1.53,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,6.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-43.68,752.22c878.47-371.4,1193.4-152.39,1696.42-33.16",
    fill: "none",
    stroke: "url(#ezaFS81XVJn25-stroke)",
    strokeWidth: 1.43,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,6.14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.25,720.91c874.26-375.41,1184.85-84.82,1697.3-15.74",
    fill: "none",
    stroke: "url(#ezaFS81XVJn26-stroke)",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,5.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.83,689.61c870.07-379.44,1176.3-17.23,1698.2,1.66",
    fill: "none",
    stroke: "url(#ezaFS81XVJn27-stroke)",
    strokeWidth: 1.23,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,5.78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.39,658.3c865.88-383.49,1167.75,50.4,1699.1,19.03",
    fill: "none",
    stroke: "url(#ezaFS81XVJn28-stroke)",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,5.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.97,627c861.72-387.57,1159.21,118.08,1700.05,36.38",
    fill: "none",
    stroke: "url(#ezaFS81XVJn29-stroke)",
    strokeWidth: 1.04,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,5.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.54,595.7c857.55-391.68,1150.67,185.79,1701.01,53.68",
    fill: "none",
    stroke: "url(#ezaFS81XVJn30-stroke)",
    strokeWidth: 0.94,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,5.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-53.12,564.4c853.4-395.81,1142.14,253.54,1701.99,70.95",
    fill: "none",
    stroke: "url(#ezaFS81XVJn31-stroke)",
    strokeWidth: 0.84,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,5.06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-54.68,533.1C794.54,133.15,1078.9,854.43,1648.27,621.29",
    fill: "none",
    stroke: "url(#ezaFS81XVJn32-stroke)",
    strokeWidth: 0.74,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.26,501.81C788.8,97.69,1068.78,890.96,1647.68,607.2",
    fill: "none",
    stroke: "url(#ezaFS81XVJn33-stroke)",
    strokeWidth: 0.64,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,4.71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-57.83,470.51C783.05,62.21,1058.65,927.5,1647.08,593.08",
    fill: "none",
    stroke: "url(#ezaFS81XVJn34-stroke)",
    strokeWidth: 0.54,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,4.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-59.39,439.22C777.31,26.73,1048.52,964.07,1646.47,578.94",
    fill: "none",
    stroke: "url(#ezaFS81XVJn35-stroke)",
    strokeWidth: 0.45,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-60.96,407.93C771.55,-8.78,1038.37,1000.67,1645.86,564.78",
    fill: "none",
    stroke: "url(#ezaFS81XVJn36-stroke)",
    strokeWidth: 0.35,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,4.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.53,376.64c828.32-420.95,1090.76,660.64,1707.78,173.95",
    fill: "none",
    stroke: "url(#ezaFS81XVJn37-stroke)",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "0,0,0,4"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "ezaFS81XVJn38"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1559.72,
    height: 1039.82,
    rx: 0,
    ry: 0,
    fill: "none"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/SVG.2dafc5b2cec742e83fa222c9d20622fa.svg";
export { ForwardRef as ReactComponent };